import { Box, Typography } from "@mui/material";

export default function EventInfo() {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: { xs: "center", md: "start" },
        gap: "1em",
        flex: 1,
      }}
    >
      <img
        src="./images/pyxizWhiteLogo.png"
        alt=""
        style={{ maxWidth: "300px" }}
      />
      <Typography
        variant="subtitle1"
        sx={{ color: "#FFF", fontFamily: "Lato" }}
      >
        Registration For NTU Majed Event 2024
      </Typography>
      <Typography
        variant="subtitle2"
        sx={{ color: "#FFF", fontFamily: "Lato" }}
      >
        Start 20 February 2024, Wednesday
      </Typography>
    </Box>
  );
}
